// extracted by mini-css-extract-plugin
export default {"wrapper":"UP9j0azSyh","inner":"uQmyA10YxQ","section":"mE6Rw0G8OO"};